import { useTranslation } from "react-i18next";
import "../styleSheets/aboutFull.css";

function AboutFull() {
  const { t } = useTranslation("common");

  return (
    <section className="section-about-full" aria-labelledby="about-full-title">
      <div className="aboutFull-container">
        <div className="text-container">
          <h1 id="about-full-title" className="title">
            {t("footer.menu.aboutUs")}
          </h1>
          <div className="our-history-container">
            <div className="our-history-area">
              <blockquote className="quote">
                {t("pageBody.about.aboutPageQuote1")}
              </blockquote>
              <div className="divider" />
              <div className="text-area">
                <p className="text-below-quote">
                  {t("pageBody.about.aboutPageQuote2")}
                </p>
                <br />
                <p className="text-below-quote">
                  {t("pageBody.about.aboutPageQuote3")}
                </p>
              </div>
            </div>
            <div className="our-history-area">
              <blockquote className="quote">
                {t("pageBody.about.aboutPageQuote4")}
              </blockquote>
              <div className="divider" />
              <div className="text-area">
                <p className="text-below-quote">
                  {t("pageBody.about.aboutPageQuote5")}
                </p>
                <br />
                <p className="text-below-quote">
                  {t("pageBody.about.aboutPageQuote6")}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="aboutFull-photo-container">
          <div className="photo-frame pic-1-frame">
            <div className="photo-dad-and-me" />
          </div>
          <div className="photo-frame pic-2-frame">
            <div className="photo-family" />
          </div>
          <div className="photo-frame pic-3-frame">
            <div className="photo-dad" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutFull;
